/** Surface colors — shared by the track renderer, the HUD and the tuning panel. */

import type { SurfaceId } from '@microligue/shared';

// Palette « planche voitures » (2026-07-21) : des aplats francs, tirés vers
// l'encre #20222e du kit de design, qui laissent les carrosseries vives lire
// par-dessus. Adjacent surfaces must be readable at race speed: the pairs that
// touch on the test track (asphalt/wet, snow/ice) differ in luminance, not
// only in hue.
export const SURFACE_COLORS: Record<SurfaceId, string> = {
  asphalt: '#4e5566',
  wet: '#39445c',
  dirt: '#a9764a',
  snow: '#eef1f4',
  ice: '#9fd8ef',
};

/**
 * Surfaces « froides » : autour d'elles le monde est enneigé (manteau au sol
 * dans render.ts, props hivernaux dans scenery.ts) — de la verdure contre un
 * ruban de glace n'était pas raccord.
 */
export function isColdSurface(surface: SurfaceId): boolean {
  return surface === 'snow' || surface === 'ice';
}
